import { render, staticRenderFns } from "./DuplicateProductForm.vue?vue&type=template&id=ba1628f4&scoped=true"
import script from "./DuplicateProductForm.vue?vue&type=script&lang=js"
export * from "./DuplicateProductForm.vue?vue&type=script&lang=js"
import style0 from "./DuplicateProductForm.vue?vue&type=style&index=0&id=ba1628f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1628f4",
  null
  
)

export default component.exports